module.exports = __webpack_public_path__ + "img/one.f6767df9.png";